import React, { Component, PropTypes } from 'react';
import BodyStyleRow from './BodyStyleRow';

/**
 * The Vehicle grid is the displays the different Body Styles
 * for the vehicles and allows the user to select a body style
 * to then choose a trim for
 */
class VehicleGrid extends Component {
  static propTypes = {
    bodyStyles: PropTypes.array.isRequired,
  };
  renderBodyStyleRows() {
    const { bodyStyles } = this.props;

    return bodyStyles.map(bodyStyle => (
      <BodyStyleRow key={bodyStyle.slug} id={bodyStyle.slug} title={bodyStyle.name} />
    ))
  }
  render() {
    return (
      <div className="nna-vehicle-grid">
        {this.renderBodyStyleRows()}
      </div>
    );
  }
}

export default VehicleGrid



/** WEBPACK FOOTER **
 ** ./src/pages/ModelLineSelect/VehicleGrid/index.js
 **/